const LOCALSTORAGE_ACCESS_TOKEN_KEY = "accessToken";
const LOCALSTORAGE_REFRESH_TOKEN_KEY = "refreshToken";
const LOCALSTORAGE_REFRESH_TOKEN_ID_KEY = "refreshTokenId";
const LOCALSTORAGE_ADMIN_MODE_KEY = "adminMode";

export const saveAccessToken = (accessToken: string): void => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN_KEY, accessToken);
};

export const getAccessToken = (): string => {
  return localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN_KEY) ?? "";
};

export const saveRefreshToken = (refreshToken: string): void => {
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN_KEY, refreshToken);
};

export const getRefreshToken = (): string => {
  return localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN_KEY) ?? "";
};

export const saveRefreshTokenId = (refreshToken: string): void => {
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN_ID_KEY, refreshToken);
};

export const getRefreshTokenId = (): string => {
  return localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN_ID_KEY) ?? "";
};

export const deleteTokens = (): void => {
  localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN_ID_KEY);
  localStorage.removeItem(LOCALSTORAGE_ADMIN_MODE_KEY);
};

export const setAdminMode = (isAdminMode: boolean): void => {
  localStorage.setItem(LOCALSTORAGE_ADMIN_MODE_KEY, String(isAdminMode));
};

export const getAdminMode = (): boolean => {
  return localStorage.getItem(LOCALSTORAGE_ADMIN_MODE_KEY) === "true";
};
